/*
 * @Author: lizhigang
 * @Date: 2025-12-08
 * @Company: www.smm.cn
 * @Description: SignIn 工具函数
 */

import http from "@repo/ui/utils"
import { message } from "antd"

import { getCookie } from "./actions"
import { COOKIE_DEFAULT_KEY } from "./const"

/**
 * 是否移动端
 */
export const isMobile = () => {
  if (typeof window !== "undefined") {
    const ua = navigator.userAgent.toLowerCase()
    return /iphone|ipod|ipad|android|mobile|blackberry|iemobile|opera mini|mobi/i.test(ua)
  }
  return false
}

/**
 * 过滤中文字符（包括中文汉字、标点符号和全角字符）
 * @param value - 需要过滤的字符串
 * @returns 过滤后的字符串
 */
export const filterChinese = (value: string): string => {
  // 移除所有中文字符
  // \u4e00-\u9fa5: 中文汉字
  // \u3000-\u303f: 中文标点符号
  // \uff00-\uffef: 全角字符
  return value.replace(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g, "")
}

/**
 * 发送位置信息到服务器
 * @param locale - 当前语言
 * @param cb - 完成后的回调函数
 */
export const sendLatLng = async (locale: string, cb?: () => void) => {
  const SMM_location = await getCookie("SMM_location")
  const token = await getCookie(COOKIE_DEFAULT_KEY)
  let location: any = {}
  let auth_token: string = ""

  if (SMM_location) {
    location = JSON.parse(decodeURIComponent(SMM_location || ""))
  } else {
    cb?.()
    return
  }

  if (token) {
    auth_token = token
  } else {
    cb?.()
    return
  }

  if (location) {
    const lat_lng = `${location.latitude},${location.longitude}`

    const formData = new FormData()
    formData.append("device_type", "en")
    formData.append("lat_lng", lat_lng)
    formData.append("auth_token", auth_token)
    await http.post(`/usercenter/4.0/start_app`, {
      params: formData,
      showOriginResponse: true,
      getLang: () => locale,
    })
    console.log("sendLatLng success")
  } else {
    console.log("sendLatLng failed:location does no exist")
  }
  cb?.()
}

/**
 * 判断用户是否需要补充信息
 * @param token - 用户 token
 * @param locale - 当前语言
 * @returns 是否需要补充信息
 */
export const fetchNecessary = async (token: string, locale: string): Promise<boolean | undefined> => {
  try {
    const response = await http.get<null, { is_necessary: boolean }>(
      `/usercenter/en/necessary_to_complete?auth_token=${token}`,
      {
        showOriginResponse: true,
        getLang: () => locale,
      }
    )
    if (response?.code === 0) {
      return response.data?.is_necessary
    }
    throw new Error(response?.msg)
  } catch (errorInfo) {
    const msg = typeof errorInfo === "string" ? errorInfo : (errorInfo as Error).message
    message.error({
      className: "sign-in-api-toast",
      content: msg || "unknown error",
    })
  }
}
